import { useTranslation } from 'react-i18next';
import { Avatar } from '@/components';
import binanceSvg from '@/assets/images/binance.svg';
import { LeaderboardMemberDto, ProfileInfoDtoRead } from '@/store/services/MidleNestApi.service';

interface Props {
  title: string;
  giveawayEntities?: ProfileInfoDtoRead[] | null;
  leaderBoardEntities?: LeaderboardMemberDto[] | null;
  totalReward?: number;
  rewardToken?: string;
  className?: string;
}

export default function BannerContent({
  title,
  giveawayEntities,
  leaderBoardEntities,
  totalReward,
  rewardToken,
  className = '',
}: Props) {
  const { t } = useTranslation();

  return (
    <div
      // className={`border-2 dark:bg-[linear-gradient(151deg,rgba(250,250,250,0.50)-0%,rgba(250,250,250,0.20)-100%)] backdrop-blur border-white shadow-xl rounded-[20px] p-4 sm:p-10 ${className}`}
      className={`border-2 bg-[linear-gradient(151deg,rgba(250,250,250,0.50)0%,rgba(250,250,250,0.20)100%)] dark:bg-[linear-gradient(151deg,rgba(55,55,55,0.50)0%,rgba(31,31,31,1)100%)] backdrop-blur border-white dark:border-white/50 shadow-xl rounded-[20px] p-4 sm:p-10 ${className}`}
    >
      {/* <select */}
      {/*   className='bg-transparent ml-auto lg:mx-auto w-28 h-8 sm:w-36 sm:h-10 border sm:border-2 border-white rounded-lg mb-4 sm:mb-6 pl-2 sm:pl-4 appearance-none bg-no-repeat text-xs leading-4 font-normal sm:text-base sm:leading-6 sm:font-normal outline-none' */}
      {/*   style={{ backgroundImage: `url(${arrowBottom})`, backgroundPosition: '93% 53%' }} */}
      {/* > */}
      {/*   <option selected disabled> */}
      {/*     Select Month */}
      {/*   </option> */}
      {/* </select> */}
      <div className='h-full flex flex-col items-center justify-items-stretch'>
        <p className='font-semibold text-lg md:text-xl'>{title}</p>

        <div className='my-1 md:my-4 lg:my-8 grow flex flex-wrap items-center justify-center'>
          {giveawayEntities &&
            giveawayEntities?.map((i, k) => (
              <div
                key={i?.id || k}
                className='p-1.5 sm:p-3 flex flex-col items-center justify-center'
                // title={String(user?.username)} // TODO: Fixme
              >
                <Avatar
                  name={String(i?.user?.username)}
                  // TODO fix userDto as profileDto [GC]
                  // src={i?.media?.path}
                  src={i?.avatar?.src}
                  className='w-20 h-20 border-2 m-1'
                />
                <span className='w-20 text-center text-sm md:text-xl overflow-hidden whitespace-nowrap truncate'>
                  {i?.user?.username}
                </span>
              </div>
            ))}
          {leaderBoardEntities &&
            leaderBoardEntities.map((user, index) => (
              <div
                key={index}
                className='p-1.5 sm:p-3 flex flex-col items-center justify-center'
                title={String(user?.name)}
              >
                <Avatar
                  name={String(user?.name)}
                  src={user?.image}
                  className='w-20 h-20 border-2 m-1'
                />
                <span className='w-20 text-center text-sm md:text-xl overflow-hidden whitespace-nowrap truncate'>
                  {user?.name}
                </span>
              </div>
            ))}
        </div>

        {totalReward && (
          <p className='text-center text-2xl md:text-4xl drop-shadow-lg'>
            {t('Prize')}{' '}
            <span className='text-3xl md:text-5xl font-semibold'>
              {totalReward} {rewardToken}
            </span>
          </p>
        )}
      </div>
    </div>
  );
}
